export enum SurveyActionsTypes {
  "LIST_SURVEY" = "LIST_SURVEY",
  "CREATE_SURVEY" = "CREATE_SURVEY",
  "UPDATE_SURVEY" = "UPDATE_SURVEY"
}

export enum SurveyMutationsTypes {
  "SET_SURVEY" = "SET_SURVEY",
  "CREATE_SURVEY" = "CREATE_SURVEY",
  "UPDATE_SURVEY" = "UPDATE_SURVEY"
}

export enum SurveyGettersTypes {
  "SURVEY_BY_ID" = "SURVEY_BY_ID",
  "SURVEY_ALL_ID" = "SURVEY_ALL_ID"
}
